import { FunctionComponent, Suspense } from "react";
import { LoadingIndicator } from "./LoadingIndicator";

export const CircularLoadingSuspense: FunctionComponent = ({ children }) => {
  return <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>;
};
